import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: [
    './home.component.css',
    '../../../assets/bootstrap/bootstrap.min.css'
  ]
})
export class HomeComponent implements OnInit {

  constructor(private titleService: Title) { }

  ngOnInit(): void {
    this.titleService.setTitle("Lejdi Prifti - About")
  }

  goToFiverr(): void {
    window.open("https://www.fiverr.com/lejdi_prifti", "_blank");
  }

  downloadCV(): void {
    const dlink: HTMLAnchorElement = document.createElement('a');
    dlink.download = 'Lejdi_Prifti_CV.pdf';
    dlink.href = '../../../assets/docs/Lejdi_Prifti_CV.pdf';
    dlink.click();
    dlink.remove();
  }

}
